import { render, staticRenderFns } from "./modalEditAttribute.vue?vue&type=template&id=4afc5584&"
import script from "./modalEditAttribute.vue?vue&type=script&lang=js&"
export * from "./modalEditAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports